<template>
  <div id="base-checkbox">
    <div class="checkbox checkbox-default">
      <input :disabled="inputDisabled" :id="id" type="checkbox" :checked="value" @change="handleChange">
      <label :for="id" :class="labelClassNames">{{ labelValue }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseCheckbox',
  props: {
    id: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
    labelValue: {
      type: String,
      default: '',
    },
    labelClassNames: {
      type: String,
      default: '',
    },
    classNames: {
      type: String,
      default: '',
    },
    inputDisabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    handleChange(event) {
      this.$emit('valueChanged', event.target.checked);
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/shared/inputs/BaseCheckbox.vue